import React from "react";
import { useHistory } from "react-router-dom";
import { ThemeType } from "../../types";

const defaultProps = { theme: "light", length: 10 };

type LoadingTableProps = {
	theme: ThemeType;
	length: number;
};

const LoadingTable = ({ theme, length }: LoadingTableProps) => {
	const history = useHistory();

	return (
		<div className="block w-full overflow-x-auto">
			{/* Projects table */}
			<table className="items-center w-full bg-transparent border-collapse">
				<thead>
					<tr>
						<th
							className={
								"px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
								(theme === "light"
									? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
									: "bg-blueGray-600 text-lightBlue-300 border-lightBlue-700")
							}
						></th>
					</tr>
				</thead>
				<tbody>
					{Array.from(Array(length))?.map((d, i) => {
						return (
							<tr
								key={i}
								className={`${
									theme === "light" ? "hover:bg-sky-50" : "hover:bg-slate-500"
								} z-10`}
								onClick={() => {
									history.push(`/user/${d._id}/info`)
								}}
							>
								<td className="table-data  text-left flex items-center w-full">
									<div className="bg-slate-200 animate-pulse w-full h-4 rounded-full my-4"></div>
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
};

LoadingTable.defaultProps = defaultProps;

export default LoadingTable;
